import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import * as _ from 'lodash-es';
import { JsonObjectFactoryService } from '../../shared/_services/json-object-factory.service';

@Injectable({
  providedIn: 'root'
})
export class Fir163jSummaryLeMeService {
  constructor(private jsonObjectFactoryService: JsonObjectFactoryService) {}

  save163jLineAmounts(
    baseUrl: string,
    data: any,
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    if (!data?.rowData || !data?.colData?.map) {
      return of({ callSuccess: '0', errorMessage: 'Invalid grid payload.' });
    }

    const row = data.rowData;
    const jsonObj = [{
      combination_key: row.COMBINATION_KEY,
      acct_key: row[`${data.colData.map}_ACCT_KEY`],
      amount: row[data.colData.map]
    }];
    const jsonSetting = [{
      le_key: row.LE_KEY,
      tax_year: row.TAX_YEAR,
      scenario: filterParams?.scenario,
      jcd_key: globalService?.globalParams?.jcd_key || 250
    }];
    const params = _.merge({}, globalService?.globalParams || globalService || {}, filterParams, {
      jsonObj: JSON.stringify(jsonObj),
      jsonSetting: JSON.stringify(jsonSetting)
    });
    return this.jsonObjectFactoryService.saveJSON6(
      `${baseUrl}/saveJsonObject?action_code=ms2967`,
      params,
      globalService,
      filterParams
    );
  }
}
